export const ledLoad = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        led:'LED',
        led_load_id:'LED Load ID',
        led_load:'LED Load',
        led_load_information:'LED Load Information',
        led_load_detail:'LED Load Details',
        add_led_load:'Add LED Load Details',
        edit_led_load:'Edit LED Load Details',
        status:'Status',
        type:'Type',
        make:'Make',
        lamp_sub_level_no:"Lamp Sub Level No",
        model_number:'Model Number',
        load_life_time_hours:'Load Life Time Hours',
        load_dimmable:'Load Dimmable(0-10V)',
        load_efficiency:'Load Efficiency',
        colour_temperature:'Colour Temperature',
        cri:'CRI',
        operating_voltage:'Operating Voltage',
        power_factor:'Power Factor',
        surge_protection:'Surge Protection',
        controller_interface:'Controller Interface',
        delete_confrim_msg:"Are you sure you want to delete this led load?",
        ledloads:"ledloads",
    },
    ar: {
        led:'يؤدى',
        led_load_id:'معرف تحميل LED',
        led_load:'معرف تحميل LED',
        led_load_information:'معلومات تحميل LED',
        led_load_detail:'تفاصيل تحميل LED',
        add_led_load:'أضف تفاصيل تحميل LED',
        edit_led_load:'تحرير تفاصيل تحميل LED',
        status:'الحالة',
        type:'النوع',
        make:'الطراز',
        lamp_sub_level_no:"رقم المستوى الفرعي للمصباح ",
        model_number:'رقم الموديل',
        load_life_time_hours:'تحميل ساعات مدى الحياة',
        load_dimmable:'تحميل خفت الضوء (0-10 فولت)',
        load_efficiency:'كفاءة التحميل',
        colour_temperature:'درجة حرارة اللون',
        cri:' ٍسي أر أي',
        operating_voltage:'جهد التشغيل',
        power_factor:'عامل القوى',
        surge_protection:'حماية الطفرة',
        controller_interface:'واجهة تحكم',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف حمل LED هذا؟",
        ledloads:"ليدلودس",
        
    }
}
